import { useMutation } from '@tanstack/react-query'
import { MainApi } from 'api/MainApi'

const useDeletedTransfer = () =>
  useMutation<void, Error, number>({
    mutationFn: MainApi.deleteTransferRoute,
  })

export default useDeletedTransfer
